export default __webpack_public_path__ + "static/media/AUGDOM2026.07f00126.png";